module.exports = __webpack_public_path__ + "static/media/facebook_reaction_anger.7ff1214d.svg";